import React, {useEffect, useRef, useState} from "react";
import {FormattedMessage} from "react-intl";
import './confirmationModal.css';

function ConfirmationModal({
                               modalName, open, onClose, title, message, warningLevel, confirmText, btnClass,
                               askInput, inputType, loading, backdrop, cancelText
                           }) {

    const modalRef = useRef(null);
    const [isOpen, setIsOpen] = useState(open);
    const [inputValue, setInputValue] = useState('');
    const inputRef = useRef(null);

    const delay = ms => new Promise(res => setTimeout(res, ms));

    useEffect(() => {
        const setFocus = async () => {
            await delay(500);
            if(inputRef?.current){
                inputRef.current?.focus();
            }
        }

        setIsOpen(open);
        if(open){
            setFocus();
        }
    }, [open]);

    function closeModal() {
        if (onClose) {
            if (askInput) {
                onClose(false, null);
            } else {
                onClose(false);
            }
        }
        setInputValue('');
    }

    async function confirmModal() {
        if (askInput && !inputValue) {
            return;
        }
        if (askInput) {
            await onClose(true, inputValue);
        } else {
            await onClose(true);
        }
        setInputValue('');
        modalRef.current?.click();
    }

    const checkEnter = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            confirmModal();
        }
    }

    return (
        <div className="modal fade" id={modalName} data-bs-backdrop={backdrop ?? "static"} data-bs-keyboard="false" tabIndex="-1"
             aria-labelledby={modalName + "Label"} aria-hidden={!isOpen}>

            <div
                className={"modal-dialog modal-dialog-centered " + (warningLevel === 'danger' ? 'shake-components-vertical' : '')}
                onKeyDown={checkEnter}>
                <div className={"modal-content"}>
                    <div className="modal-header">
                        <h5 className="modal-title">{title}</h5>
                        <button type="button" className="btn-close" disabled={loading}
                                onClick={closeModal} data-bs-dismiss="modal"></button>
                    </div>
                    <div className="modal-body">
                        {message}
                        {askInput && <div className="mt-3">
                            <div className="form-floating mb-3 col-12">
                                <input id="modalInput" value={inputValue} onChange={e => {
                                    setInputValue(e.target.value);
                                }} placeholder={askInput} autoComplete="new-password"
                                       disabled={loading} ref={inputRef}
                                       type={inputType} className={"form-control"}/>
                                <label htmlFor="modalInput">{askInput}</label>
                            </div>
                        </div>}
                    </div>
                    <div className="modal-footer">
                        <button hidden={true} ref={modalRef} data-bs-dismiss="modal">
                        </button>
                        <button onClick={closeModal} type="button" className="btn btn-secondary"
                                disabled={loading} data-bs-dismiss="modal">
                            {cancelText ?? <FormattedMessage id="modal.cancel"/>}
                        </button>
                        <button disabled={(askInput && !inputValue) || loading} onClick={confirmModal} type="button"
                                className={"btn " + (btnClass ? btnClass : 'btn-primary')}>
                            {!confirmText && <FormattedMessage id="modal.confirm"/>}
                            {confirmText && <span>{confirmText}</span>}
                            {loading && <i className="ms-2 fa-solid fa-spinner fa-spin-pulse"></i>}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ConfirmationModal;
